import Image from 'next/image';
import { FC, useState } from 'react';

interface AnchorProps {
  id?: string;
}

export const Accordion: FC<AnchorProps> = ({ id }: AnchorProps) => {
  const [active, setActive] = useState([false, false, false, false]);

  var className = active[0] ? ' collapsable--active' : 'collapsable';
  var className2 = active[1] ? ' collapsable--active' : 'collapsable';
  var className3 = active[2] ? ' collapsable--active' : 'collapsable';
  var className4 = active[3] ? ' collapsable--active' : 'collapsable';
  return (
    <>
      <div className={className}>
        <div
          onClick={() =>
            setActive([!active[0], active[1], active[2], active[3]])
          }
          className={'collapsable__head'}
        >
          <div className="collapsable__head__text">
            <p>Studio</p>
            <p>Rent - Contact us</p>
          </div>
          <div className="collapsable__btn">
            <svg width="22" height="12" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m1 1 10.278 10M21 1 10.722 11"
                stroke="#000"
                strokeWidth="1.009"
                fill="none"
              />
            </svg>
          </div>
        </div>
        <div className="collapsable__body">
          <div className="collapsable__body__inner">
            <ul className="collapsable__list">
              <li className="collapsable__list__item">Household Size</li>
              <li className="collapsable__list__item">
                Minimum Income (Based on Rent)
              </li>
              <li className="collapsable__list__item">
                Max. Income (2023 Limits)
              </li>
            </ul>
            <ul className="collapsable__list">
              <li className="collapsable__list__item">1 person</li>
              <li className="collapsable__list__item">$80,572</li>
              <li className="collapsable__list__item">$128,570</li>
            </ul>
            <ul className="collapsable__list">
              <li className="collapsable__list__item">2 people</li>
              <li className="collapsable__list__item">$80,572</li>
              <li className="collapsable__list__item">$146,900</li>
            </ul>
          </div>
        </div>
      </div>
      <div className={className2}>
        <div
          className="collapsable__head"
          onClick={() =>
            setActive([active[0], !active[1], active[2], active[3]])
          }
        >
          <div className="collapsable__head__text">
            <p>One Bedroom</p>
            <p>Rent - Contact us</p>
          </div>
          <div className="collapsable__btn">
            <svg width="22" height="12" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m1 1 10.278 10M21 1 10.722 11"
                stroke="#000"
                strokeWidth="1.009"
                fill="none"
              />
            </svg>
          </div>
        </div>
        <div className="collapsable__body">
          <div className="collapsable__body__inner">
            <ul className="collapsable__list">
              <li className="collapsable__list__item">Household Size</li>
              <li className="collapsable__list__item">
                Minimum Income (Based on Rent)
              </li>
              <li className="collapsable__list__item">
                Max. Income (2023 Limits)
              </li>
            </ul>
            <ul className="collapsable__list">
              <li className="collapsable__list__item">1 person</li>
              <li className="collapsable__list__item">$85,715</li>
              <li className="collapsable__list__item">$128,570</li>
            </ul>
            <ul className="collapsable__list">
              <li className="collapsable__list__item">2 people</li>
              <li className="collapsable__list__item">$85,715</li>
              <li className="collapsable__list__item">$146,900</li>
            </ul>
            <ul className="collapsable__list">
              <li className="collapsable__list__item">3 people</li>
              <li className="collapsable__list__item">$85,715</li>
              <li className="collapsable__list__item">$165,230</li>
            </ul>
          </div>
        </div>
      </div>
      <div className={className3}>
        <div
          className="collapsable__head"
          onClick={() =>
            setActive([active[0], active[1], !active[2], active[3]])
          }
        >
          <div className="collapsable__head__text">
            <p>One Bedroom Plus</p>
            <p>Rent - Contact us</p>
          </div>
          <div className="collapsable__btn">
            <svg width="22" height="12" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m1 1 10.278 10M21 1 10.722 11"
                stroke="#000"
                strokeWidth="1.009"
                fill="none"
              />
            </svg>
          </div>
        </div>
        <div className="collapsable__body">
          <div className="collapsable__body__inner">
            <ul className="collapsable__list">
              <li className="collapsable__list__item">Household Size</li>
              <li className="collapsable__list__item">
                Minimum Income (Based on Rent)
              </li>
              <li className="collapsable__list__item">
                Max. Income (2023 Limits)
              </li>
            </ul>
            <ul className="collapsable__list">
              <li className="collapsable__list__item">1 person</li>
              <li className="collapsable__list__item">$92,538</li>
              <li className="collapsable__list__item">$128,570</li>
            </ul>
            <ul className="collapsable__list">
              <li className="collapsable__list__item">2 people</li>
              <li className="collapsable__list__item">$92,538</li>
              <li className="collapsable__list__item">$146,900</li>
            </ul>
            <ul className="collapsable__list">
              <li className="collapsable__list__item">3 people</li>
              <li className="collapsable__list__item">$92,538</li>
              <li className="collapsable__list__item">$165,230</li>
            </ul>
          </div>
        </div>
      </div>
      <div className={className4}>
        <div
          className="collapsable__head"
          onClick={() =>
            setActive([active[0], active[1], active[2], !active[3]])
          }
        >
          <div className="collapsable__head__text">
            <p>2 Bedroom</p>
            <p>Rent - Contact us</p>
          </div>
          <div className="collapsable__btn">
            <svg width="22" height="12" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m1 1 10.278 10M21 1 10.722 11"
                stroke="#000"
                strokeWidth="1.009"
                fill="none"
              />
            </svg>
          </div>
        </div>
        <div className="collapsable__body">
          <div className="collapsable__body__inner">
            <ul className="collapsable__list">
              <li className="collapsable__list__item">Household Size</li>
              <li className="collapsable__list__item">
                Minimum Income (Based on Rent)
              </li>
              <li className="collapsable__list__item">
                Max. Income (2023 Limits)
              </li>
            </ul>
            <ul className="collapsable__list">
              <li className="collapsable__list__item">2 people</li>
              <li className="collapsable__list__item">$112,698</li>
              <li className="collapsable__list__item">$146,900</li>
            </ul>
            <ul className="collapsable__list">
              <li className="collapsable__list__item">3 people</li>
              <li className="collapsable__list__item">$112,698</li>
              <li className="collapsable__list__item">$165,230</li>
            </ul>
            <ul className="collapsable__list">
              <li className="collapsable__list__item">4 people</li>
              <li className="collapsable__list__item">$112,698</li>
              <li className="collapsable__list__item">$183,560</li>
            </ul>
            <ul className="collapsable__list">
              <li className="collapsable__list__item">5 people</li>
              <li className="collapsable__list__item">$112,698</li>
              <li className="collapsable__list__item">$198,250</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};
